import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
// FLATBUFFERS SCHEMAS
import { ElevatorTraffic } from "../../../../flatbuffers/generated/traffic/elevator-traffic";
import { EscalatorTraffic } from "../../../../flatbuffers/generated/traffic/escalator-traffic";
import { ElevatorUsage } from "../../../../flatbuffers/generated/usage/elevator-usage";
import { EscalatorUsage } from "../../../../flatbuffers/generated/usage/escalator-usage";
import { ElevatorService } from "../../../../flatbuffers/generated/service/elevator-service";
import { EscalatorService } from "../../../../flatbuffers/generated/service/escalator-service";
import { ElevatorControl } from "../../../../flatbuffers/generated/control/elevator-control";
import { EscalatorControl } from "../../../../flatbuffers/generated/control/escalator-control";
import { ElevatorFault } from "../../../../flatbuffers/generated/fault/elevator-fault";
import { EscalatorFault } from "../../../../flatbuffers/generated/fault/escalator-fault";
import { ElevatorGroupSupervisoryStatus } from "../../../../flatbuffers/generated/group-supervisory-status/elevator-group-supervisory-status";
import { EscalatorGroupSupervisoryStatus } from "../../../../flatbuffers/generated/group-supervisory-status/escalator-group-supervisory-status";
import { ElevatorGroupControl } from "../../../../flatbuffers/generated/group-control/elevator-group-control";
import { EscalatorGroupControl } from "../../../../flatbuffers/generated/group-control/escalator-group-control";
import { ElevatorControllerInfoMessage } from "../../../../flatbuffers/generated/controller-info/elevator-controller-info-message";
import { EscalatorControllerInfoMessage } from "../../../../flatbuffers/generated/controller-info/escalator-controller-info-message";
import { Status } from "../../../../flatbuffers/generated/status/status";
// INTERFACES
import { EncodedMessageContent } from "../../../../flatbuffers/generated/ln2/encoded-message-content";
import { BitMaskMessageContent } from "../../../../flatbuffers/generated/ln2/bit-mask-message-content";
import { OneHotMessageContent } from "../../../../flatbuffers/generated/ln2/one-hot-message-content";
import { LiftType } from "../../../../interfaces/Lift.interface";

export default function IconDefinitionMessagesCatalog({
	message,
	onChangeMessage,
	disabled,
	liftType,
	contentType,
	messageType,
}: {
	message: number | null;
	onChangeMessage: (newValue: number) => void;
	disabled: boolean;
	liftType: LiftType;
	contentType: EncodedMessageContent | null;
	messageType: OneHotMessageContent | BitMaskMessageContent | null;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	interface CatalogInterface {
		label: string;
		value: number;
	}

	const { Option } = Select;

	// ************************************************ */
	// FLAT BUFFERS SCHEMAS CATALOGS ****************** */
	const elevatorTrafficOptions: CatalogInterface[] = Object.entries(ElevatorTraffic)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorTrafficOptions: CatalogInterface[] = Object.entries(EscalatorTraffic)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorUsageOptions: CatalogInterface[] = Object.entries(ElevatorUsage)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorUsageOptions: CatalogInterface[] = Object.entries(EscalatorUsage)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorServiceOptions: CatalogInterface[] = Object.entries(ElevatorService)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorServiceOptions: CatalogInterface[] = Object.entries(EscalatorService)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorControlOptions: CatalogInterface[] = Object.entries(ElevatorControl)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorControlOptions: CatalogInterface[] = Object.entries(EscalatorControl)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorFaultOptions: CatalogInterface[] = Object.entries(ElevatorFault)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorFaultOptions: CatalogInterface[] = Object.entries(EscalatorFault)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorGroupSupervisoryStatusOptions: CatalogInterface[] = Object.entries(ElevatorGroupSupervisoryStatus)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorGroupSupervisoryStatusOptions: CatalogInterface[] = Object.entries(EscalatorGroupSupervisoryStatus)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorGroupControlOptions: CatalogInterface[] = Object.entries(ElevatorGroupControl)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorGroupControlOptions: CatalogInterface[] = Object.entries(EscalatorGroupControl)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorControllerInfoOptions: CatalogInterface[] = Object.entries(ElevatorControllerInfoMessage)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorControllerInfoOptions: CatalogInterface[] = Object.entries(EscalatorControllerInfoMessage)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const elevatorStatusOptions: CatalogInterface[] = Object.entries(Status)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	const escalatorStatusOptions: CatalogInterface[] = Object.entries(Status)
		.filter(([, v]) => typeof v === "number")
		.map(([label, value]: any) => ({
			label,
			value,
		}));

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [catalog, setCatalog] = useState<CatalogInterface[]>([]);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		// si no hay selección, no hay catálogo
		if (contentType == null || messageType == null) {
			setCatalog([]);
			return;
		}

		// OneHot => Usage / Service
		if (contentType === EncodedMessageContent.OneHotMessage) {
			if (messageType === OneHotMessageContent.Usage_UsageMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorUsageOptions] : [...escalatorUsageOptions]);
				return;
			}
			if (messageType === OneHotMessageContent.Service_ServiceMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorServiceOptions] : [...escalatorServiceOptions]);
				return;
			}

			setCatalog([]);
			return;
		}

		// BitMask => Traffic / Status / Control / Fault / Group... / ControllerInfo
		if (contentType === EncodedMessageContent.BitMaskMessage) {
			if (messageType === BitMaskMessageContent.Traffic_TrafficMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorTrafficOptions] : [...escalatorTrafficOptions]);
				return;
			}
			if (messageType === BitMaskMessageContent.Status_StatusMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorStatusOptions] : [...escalatorStatusOptions]);
				return;
			}
			if (messageType === BitMaskMessageContent.Control_ControlMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorControlOptions] : [...escalatorControlOptions]);
				return;
			}
			if (messageType === BitMaskMessageContent.Fault_FaultMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorFaultOptions] : [...escalatorFaultOptions]);
				return;
			}
			if (messageType === BitMaskMessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage) {
				setCatalog(
					liftType === "ELEVATOR"
						? [...elevatorGroupSupervisoryStatusOptions]
						: [...escalatorGroupSupervisoryStatusOptions],
				);
				return;
			}
			if (messageType === BitMaskMessageContent.GroupControl_GroupControlMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorGroupControlOptions] : [...escalatorGroupControlOptions]);
				return;
			}
			if (messageType === BitMaskMessageContent.ControllerInfo_ControllerInfoMessage) {
				setCatalog(liftType === "ELEVATOR" ? [...elevatorControllerInfoOptions] : [...escalatorControllerInfoOptions]);
				return;
			}

			setCatalog([]);
			return;
		}

		setCatalog([]);
	}, [liftType, contentType, messageType]);

	useEffect(() => {
		if (catalog.length > 0) {
			onChangeMessage(catalog[0].value);
		}
	}, [catalog]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Select
			optionFilterProp='children'
			className='generalStyles__width100'
			allowClear={false}
			size='small'
			value={message ?? undefined}
			onChange={(e: number) => onChangeMessage(e)}
			disabled={disabled}
		>
			{catalog.map((item) => (
				<Option key={item.label} value={item.value}>
					<FontAwesomeIcon icon={faCircle} className='generalStyles__success' style={{ marginRight: "10px" }} />
					{item.label}
				</Option>
			))}
		</Select>
	);
}
